import { render, staticRenderFns } from "./SuratPuasModal.vue?vue&type=template&id=d6e3e988&scoped=true"
import script from "./SuratPuasModal.vue?vue&type=script&lang=js"
export * from "./SuratPuasModal.vue?vue&type=script&lang=js"
import style0 from "./SuratPuasModal.vue?vue&type=style&index=0&id=d6e3e988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e3e988",
  null
  
)

export default component.exports